import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Status, StatusView } from './status.model';
import { QueryParams, QueryResult } from '../../../core/store/models/query.model';
import { HttpService } from '../../../core/services/http.service';
import { WorkflowTranslation } from '../workflow';

import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';

@Injectable({
  providedIn: 'root'
})
export class StatusApiService {
  constructor(private http: HttpService) {}

  public getStatuses(params: QueryParams, includeTranslations: boolean): Observable<QueryResult<Status>> {
    const request = {
      ...params,
      includeTranslations: includeTranslations
    };

    const queryString = this.http.queryStringFromObject(request);

    const url = `${apiBaseUrl}/v1/meta/workflows/workflowStatuses?${queryString}`;

    return this.http.get<QueryResult<Status>>(url);
  }

  public insertStatus(status: Status): Observable<Status> {
    const url = `${apiBaseUrl}/v1/meta/workflows/workflowStatuses`;

    return this.http.post<Status>(url, status);
  }

  public updateStatus(status: Status): Observable<Status> {
    const url = `${apiBaseUrl}/v1/meta/workflows/workflowStatuses/${status.uId}`;

    return this.http.put<Status>(url, status);
  }

  public updateStatusItems(statusItems: Status[]): Observable<Status[]> {
    const url = `${apiBaseUrl}/v1/meta/workflows/workflowStatuses/items`;

    const request = {
      statusItems: statusItems
    }

    return this.http.post<Status[]>(url, request);
  }

  public deleteStatus(status: Status): Observable<Status> {
    const url = `${apiBaseUrl}/v1/meta/workflows/workflowStatuses/${status.uId}`;

    return this.http.delete(url);
  }

  public getStatusView(statusUId: string): Observable<StatusView[]> {
    const url = `${apiBaseUrl}/v1/meta/workflows/workflowStatuses/${statusUId}/view`;

    return this.http.get<StatusView[]>(url);
  }

  public getStatusTranslations(statusUId: string): Observable<WorkflowTranslation[]> {
    const url = `${apiBaseUrl}/v1/meta/workflows/workflowStatuses/${statusUId}/translations`;

    return this.http.get<WorkflowTranslation[]>(url);
  }
}
